import { useDispatch, useSelector } from "react-redux";
import { regexHaveLowerCase, regexHaveNumber, regexHaveUppercase } from "@/utils/functions";
import ForgotPasswordDataView from "./view";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { changePassword } from "@/redux/ducks/customer";
import { ReducersTypes } from "@/redux/reducers/Models";

export default function ForgotPasswordData() {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);

  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [isVisiblePassword, setIsVisiblePassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isVisibleConfirmPassword, setIsVisibleConfirmPassword] = useState(false);


  const goBack = () => navigate(-1);

  const goToLogin = () => navigate("/");

  const toggleIsVisiblePassword = () => setIsVisiblePassword(isVisiblePassword => !isVisiblePassword);
  const toggleIsVisibleConfirmPassword = () => setIsVisibleConfirmPassword(isVisibleConfirmPassword => !isVisibleConfirmPassword);

  const items = [
    {
      text: 'Ter no Mínimo 8 Caracteres e no Máximo 20 Caracteres',
      success: password?.length >= 8 && password?.length <= 20,
    },
    {
      text: 'Pelo Menos 1 Letra Maiúscula',
      success: regexHaveUppercase.test(password),
    },
    {
      text: 'Pelo Menos 1 Letra Minúscula',
      success: regexHaveLowerCase.test(password),
    },
    {
      text: 'Pelo Menos 1 Número',
      success: regexHaveNumber.test(password),
    },
  ];

  const itemsConfirm = [
    {
      text: 'As senhas precisam ser iguais',
      success: !items?.find(item => !item.success) && password === confirmPassword,
    },
  ];

  const [validatesPassword, setValidatesPassword] = useState(items);
  const [validatesConfirmPassword, setValidatesConfirmPassword] = useState(itemsConfirm);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === "password") setPassword(value);
    if (name === "confirmPassword") setConfirmPassword(value);
  }

  const getIsDisabled = () => {
    if (validatesPassword?.some(item => !item.success) || password !== confirmPassword
      || validatesConfirmPassword?.some(item => !item.success)) return true;
    return false;
  }

  const handleChangePassword = (success: boolean, errorMessage?: string) => {
    setIsLoading(false);

    if (!success) {
      setError(true);
      return;
    }

    setSuccess(true);
  };

  const submit = () => {
    if (getIsDisabled() || isLoading) return;

    setIsLoading(true);
    setError(false);
    setSuccess(false);

    const forgot = customer?.forgot;

    dispatch(
      changePassword({
        document: forgot?.document!,
        pin: forgot?.pin!,
        hashCode: forgot?.hashCode!,
        newPassword: password,
        callback: handleChangePassword,
      })
    );
  }

  useEffect(() => {
    setValidatesPassword(items);
    setValidatesConfirmPassword(itemsConfirm);
  }, [password, confirmPassword]);

  return <ForgotPasswordDataView
    goBack={goBack}
    onChange={onChange}
    submit={submit}
    isDisabled={getIsDisabled()}
    goToLogin={goToLogin}
    validatesPassword={validatesPassword}
    validatesConfirmPassword={validatesConfirmPassword}
    isVisiblePassword={isVisiblePassword}
    isVisibleConfirmPassword={isVisibleConfirmPassword}
    toggleIsVisiblePassword={toggleIsVisiblePassword}
    toggleIsVisibleConfirmPassword={toggleIsVisibleConfirmPassword}
    error={error}
    setError={setError}
    success={success}
    setSuccess={setSuccess}
    isLoading={isLoading}
    password={password}
    confirmPassword={confirmPassword}
  />;
}
